/**
 * 

apps/v4/registry/new-york-v4/ui/button.tsx

https://github.com/shadcn-ui/ui/tree/main/apps/v4/registry/new-york-v4/ui
	*/
import { cn, cva, type VariantProps } from "./utils"

const buttonVariants = cva(
  `
    focus-visible:ring-ring
    inline-flex items-center justify-center gap-2 rounded-md text-sm leading-none font-medium
    whitespace-nowrap ring-offset-background transition-[color,background-color,border-color,transform] ease-[var(--ease-standard)]
    active:scale-[0.97]
    focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none
    disabled:pointer-events-none disabled:opacity-50
    [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0
  `,
  {
    defaultVariants: {
      size: "default",
      variant: "default",
    },
    variants: {
      size: {
        default: "h-10 px-4 py-2",
        icon: "size-10",
        lg: "h-14 rounded-md px-10 text-2xl",
        sm: "h-8 rounded-md px-3 text-xs",
      },
      variant: {
        default: `
          border border-input bg-primary text-primary-foreground
          hover:bg-primary/90
        `,
        destructive: `
          border border-input bg-destructive text-success-foreground
          hover:bg-destructive/90
        `,
        link: `
          border border-input text-primary underline-offset-4
          hover:underline
        `,
        outline: "border border-input",
        secondary: `
          border border-input bg-secondary text-secondary-foreground
          hover:bg-secondary/80
        `,
        success:
          "border border-input bg-success-background text-success-foreground",
        transparent:
          "border border-transparent bg-transparent text-foreground hover:bg-muted/50",
      },
    },
  },
)

export interface ButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

function Button({
  className,
  ref,
  size,
  variant,
  ...props
}: ButtonProps & { ref?: React.Ref<HTMLButtonElement> }) {
  return (
    <button
      className={cn(
        buttonVariants({ className, size, variant }),
        "cursor-pointer",
      )}
      ref={ref}
      {...props}
    />
  )
}

export { Button }
